/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from 'react';
import { StyledTextLink, StyledIcon } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
const hasHref = (props) => {
    return typeof props.href === 'string';
};
export const TextLink = forwardRef((props, ref) => {
    const { children, weight = 'normal', icon, variant, size, role, 'data-testid': dataTestId, 'aria-label': ariaLabel, 'data-aue-type': dataAueType, 'data-aue-resource': dataAueRessource, 'data-aue-label': dataAueLabel, 'data-aue-prop': dataAueProp, 'data-aue-behavior': dataAueBehavior, 'data-aue-filter': dataAueFilter, 'data-aue-model': dataAueModel, iconPosition, title, margin, className, id } = props;
    const baseProps = {
        'data-testid': dataTestId,
        'aria-label': ariaLabel,
        'data-aue-type': dataAueType,
        'data-aue-resource': dataAueRessource,
        'data-aue-label': dataAueLabel,
        'data-aue-prop': dataAueProp,
        'data-aue-behavior': dataAueBehavior,
        'data-aue-filter': dataAueFilter,
        'data-aue-model': dataAueModel,
        children,
        className,
        role,
        title,
        margin,
        ref,
        icon,
        id
    };
    const iconSize = size === 'md' ? 's' : 'xs';
    const iconElement = icon && (React.createElement(StyledIcon, { name: icon, size: iconSize, iconPosition: iconPosition, variant: variant }));
    const content = (React.createElement(React.Fragment, null,
        variant !== 'inline' && iconPosition === 'leading' && iconElement,
        children,
        (iconPosition === 'trailing' || variant === 'inline') && iconElement));
    if (hasHref(props)) {
        const { href, onClick, target, rel } = props;
        const textLinkAsLinkProps = {
            href,
            onClick,
            target,
            rel
        };
        if (variant === 'standalone') {
            return (React.createElement(StyledTextLink, { ...baseProps, ...textLinkAsLinkProps, as: "a", size: size, variant: variant, iconPosition: iconPosition }, content));
        }
        return (React.createElement(StyledTextLink, { ...baseProps, ...textLinkAsLinkProps, as: "a", size: size, variant: variant, weight: weight }, content));
    }
    const { disabled, onClick, type = 'button' } = props;
    const textLinkAsButtonProps = {
        onClick,
        type,
        disabled
    };
    if (variant === 'standalone') {
        return (React.createElement(StyledTextLink, { ...baseProps, ...textLinkAsButtonProps, as: "button", size: size, variant: variant, iconPosition: iconPosition }, content));
    }
    return (React.createElement(StyledTextLink, { ...baseProps, ...textLinkAsButtonProps, as: "button", size: size, variant: variant, weight: weight }, content));
});
TextLink.displayName = 'TextLink';
//# sourceMappingURL=index.js.map